"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.delayedVestingAccount = void 0;
var ow_1 = __importDefault(require("ow"));
var long_1 = __importDefault(require("long"));
var ow_types_1 = require("../ow.types");
var typeurl_1 = require("../../common/constants/typeurl");
var cro_1 = require("../../../core/cro");
exports.delayedVestingAccount = function (config) {
    return (function () {
        function DelayedVestingAccount(options) {
            ow_1.default(options, 'options', ow_types_1.owDelayedVestingAccountOptions);
            this.baseAccount = options.baseAccount;
            this.originalVesting = options.originalVesting;
            this.delegatedFree = options.delegatedFree;
            this.delegatedVesting = options.delegatedVesting;
            this.endTime = options.endTime;
        }
        DelayedVestingAccount.fromCosmosMsgJSON = function (msgJsonStr) {
            var _a, _b, _c;
            var parsedMsg = JSON.parse(msgJsonStr);
            var cro = cro_1.CroSDK({ network: config.network });
            if (parsedMsg['@type'] !== typeurl_1.COSMOS_MSG_TYPEURL.account.DelayedVestingAccount) {
                throw new Error("Expected " + typeurl_1.COSMOS_MSG_TYPEURL.account.DelayedVestingAccount + " but got " + parsedMsg['@type']);
            }
            if (parsedMsg.base_vesting_account.delegated_vesting.length < 1 ||
                parsedMsg.base_vesting_account.original_vesting.length < 1 ||
                parsedMsg.base_vesting_account.delegated_free.length < 1) {
                throw new Error('Invalid Amount fields in the Msg.');
            }
            return new DelayedVestingAccount({
                baseAccount: {
                    address: (_a = parsedMsg.base_vesting_account.base_account) === null || _a === void 0 ? void 0 : _a.address,
                    accountNumber: long_1.default.fromString(((_b = parsedMsg.base_vesting_account.base_account) === null || _b === void 0 ? void 0 : _b.account_number) || '0'),
                    sequence: long_1.default.fromString(((_c = parsedMsg.base_vesting_account.base_account) === null || _c === void 0 ? void 0 : _c.sequence) || '0'),
                },
                originalVesting: parsedMsg.base_vesting_account.original_vesting.map(function (coin) {
                    return cro.v2.CoinV2.fromCustomAmountDenom(coin.amount, coin.denom);
                }),
                delegatedFree: parsedMsg.base_vesting_account.delegated_free.map(function (coin) {
                    return cro.v2.CoinV2.fromCustomAmountDenom(coin.amount, coin.denom);
                }),
                delegatedVesting: parsedMsg.base_vesting_account.delegated_vesting.map(function (coin) {
                    return cro.v2.CoinV2.fromCustomAmountDenom(coin.amount, coin.denom);
                }),
                endTime: long_1.default.fromString(parsedMsg.base_vesting_account.end_time || '0'),
            });
        };
        DelayedVestingAccount.prototype.toRawMsg = function () {
            var _a, _b, _c;
            return {
                typeUrl: typeurl_1.COSMOS_MSG_TYPEURL.account.DelayedVestingAccount,
                value: {
                    baseVestingAccount: {
                        baseAccount: {
                            address: (_a = this.baseAccount) === null || _a === void 0 ? void 0 : _a.address,
                            accountNumber: (_b = this.baseAccount) === null || _b === void 0 ? void 0 : _b.accountNumber,
                            sequence: (_c = this.baseAccount) === null || _c === void 0 ? void 0 : _c.sequence,
                        },
                        originalVesting: this.originalVesting.map(function (amt) { return amt.toCosmosCoin(); }),
                        delegatedFree: this.delegatedFree.map(function (amt) { return amt.toCosmosCoin(); }),
                        delegatedVesting: this.delegatedVesting.map(function (amt) { return amt.toCosmosCoin(); }),
                        endTime: this.endTime,
                    },
                },
            };
        };
        DelayedVestingAccount.prototype.toRawAminoMsg = function () {
            throw new Error("DelayedVestingAccount isn't supported for Amino encoding.");
        };
        return DelayedVestingAccount;
    }());
};
//# sourceMappingURL=DelayedVestingAccount.js.map